export const getCanvas2DContext = (
    canvasRef: React.RefObject<HTMLCanvasElement>
) => {
    if (!canvasRef.current) {
        return null
    }
    return canvasRef.current.getContext('2d') || null
}
